<script>
  import { onMount } from "svelte";

  import { createDetailMap } from "./map-utils";

  /*
   * Component props
   */

  export let mapId = "detailMap";
  export let address = "";
  export let city = "";
  export let country = "";
  export let centerY;
  export let centerX;

  /*
   * Lifecycle functions
   */

  onMount(() => {
    let coords = [centerY, centerX];
    createDetailMap({
      mapId: mapId,
      mapCenter: coords,
      markerPosition: coords,
      circlePosition: coords,
    });
  });
</script>

<div class="mb-5">
  <h5 class="mt-0 mb-3">Find Us</h5>
  <p>
    <i class="fa-map-marker-alt fas mr-2 text-success" />
    {#if address}{address},{/if}
    {#if city}{city},{/if}
    {country}
  </p>
  <div class="map-wrapper-300 mb-2 shadow">
    <!-- override z-index to sit underneath modals -->
    <div id="detailMap" class="h-100 z-index-0" />
  </div>
  <div class="d-flex align-items-center justify-content-center">
    <span class="mr-2 ml-2">
      <img src="/static/images/tab-map-circle-legend.svg" alt="Map legend" />
    </span>
    <span>10-15 minutes walking</span>
    <span class="text-muted ml-2">1km/0.6miles</span>
  </div>
</div>
